import { createAccessRequest, getOwnAccessRequests, getAccessRequests, updateAccessRequest, deleteAccessRequest} from '../../util/api';

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/AccessRequestPage/SET_INITIAL_STATE';

export const CREATE_ACCESS_REQUEST = 'app/AccessRequestPage/CREATE_ACCESS_REQUEST';
export const CREATE_ACCESS_SUCCESS = 'app/AccessRequestPage/CREATE_ACCESS_SUCCESS';
export const CREATE_ACCESS_ERROR = 'app/AccessRequestPage/CREATE_ACCESS_ERROR';

export const GET_OWN_ACCESS_REQUESTS = 'app/AccessRequestPage/GET_OWN_ACCESS_REQUESTS';
export const GET_OWN_ACCESS_SUCCESS = 'app/AccessRequestPage/GET_OWN_ACCESS_SUCCESS';
export const GET_OWN_ACCESS_ERROR = 'app/AccessRequestPage/GET_OWN_ACCESS_ERROR';

export const GET_ACCESS_REQUESTS = 'app/AccessRequestPage/GET_ACCESS_REQUESTS';
export const GET_ACCESS_SUCCESS = 'app/AccessRequestPage/GET_ACCESS_SUCCESS';
export const GET_ACCESS_ERROR = 'app/AccessRequestPage/GET_ACCESS_ERROR';

export const UPDATE_ACCESS_REQUESTS = 'app/AccessRequestPage/UPDATE_ACCESS_REQUESTS';
export const UPDATE_ACCESS_SUCCESS = 'app/AccessRequestPage/UPDATE_ACCESS_SUCCESS';
export const UPDATE_ACCESS_ERROR = 'app/AccessRequestPage/UPDATE_ACCESS_ERROR';

export const DELETE_ACCESS_REQUESTS = 'app/AccessRequestPage/DELETE_ACCESS_REQUESTS';
export const DELETE_ACCESS_SUCCESS = 'app/AccessRequestPage/DELETE_ACCESS_SUCCESS';
export const DELETE_ACCESS_ERROR = 'app/AccessRequestPage/DELETE_ACCESS_ERROR';






const initialState = {
    createAccessInProgress: false,
    createAccessError: null,
    getOwnRequestsInProgress: false,
    getOwnRequestsError: null,
    ownRequests: [],
    getRequestsInProgress: false,
    getRequestsError: null,
    requests: [],
    updateRequestInProgress:false,
    updateRequestError:null,
    message:null,
    deleteRequestInProgress:false,
    deleteRequestError:null,
    loadingId:null,
};

export default function AccessRequestPage(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case SET_INITIAL_STATE:
            return { ...initialState , message: state.message  };

        case CREATE_ACCESS_REQUEST:
            return { ...state, createAccessError: null, createAccessInProgress: true};

        case CREATE_ACCESS_SUCCESS:
            return { ...state, createAccessInProgress: false, message: payload };

        case CREATE_ACCESS_ERROR:
            return { ...state, createAccessError: payload, createAccessInProgress: false ,  message: null };


        case GET_OWN_ACCESS_REQUESTS:
            return { ...state, getOwnRequestsError: null, getOwnRequestsInProgress: true };

        case GET_OWN_ACCESS_SUCCESS:
            return { ...state, getOwnRequestsInProgress: false, ownRequests: payload };

        case GET_OWN_ACCESS_ERROR:
            return { ...state, getOwnRequestsError: payload, getOwnRequestsInProgress: false };


             case GET_ACCESS_REQUESTS:
            return { ...state, getRequestsError: null, getRequestsInProgress: true , message: state.message };

        case GET_ACCESS_SUCCESS:
            return { ...state, getRequestsInProgress: false, requests: payload };

        case GET_ACCESS_ERROR:
            return { ...state, getRequestsError: payload, getRequestsInProgress: false };

              case UPDATE_ACCESS_REQUESTS:
            return { ...state, updateRequestError: null, updateRequestInProgress: true };

        case UPDATE_ACCESS_SUCCESS:
            return { ...state, updateRequestInProgress: false };

        case UPDATE_ACCESS_ERROR:
            return { ...state, updateRequestError: payload, updateRequestInProgress: false };

               case DELETE_ACCESS_REQUESTS:
            return { ...state, deleteRequestError: null, deleteRequestInProgress: true ,loadingId:payload};

        case DELETE_ACCESS_SUCCESS:
            return { ...state, deleteRequestInProgress: false, loadingId:null};

        case DELETE_ACCESS_ERROR:
            return { ...state, deleteRequestError: payload, deleteRequestInProgress: false, loadingId:null };

        default:
            return state;

    }
}

// ================ Action creators ================ //

export const setInitialState = () => ({
    type: SET_INITIAL_STATE,
});


export const createAccessUserRequest = () => ({
    type: CREATE_ACCESS_REQUEST,
});

export const createAccessSuccess = (message) => ({
    type: CREATE_ACCESS_SUCCESS,
    payload: message,
});

export const createAccessError = e => ({
    type: CREATE_ACCESS_ERROR,
    error: true,
    payload: e,
});


export const getOwnUserAccessRequests = () => ({
    type: GET_OWN_ACCESS_REQUESTS,
});

export const getOwnAccessSuccess = (data) => ({
    type: GET_OWN_ACCESS_SUCCESS,
    payload: data,
});

export const getOwnAccessError = e => ({
    type: GET_OWN_ACCESS_ERROR,
    error: true,
    payload: e,
});


export const getUserAccessRequests = () => ({
    type: GET_ACCESS_REQUESTS,
});

export const getAccessSuccess = (data) => ({
    type: GET_ACCESS_SUCCESS,
    payload: data,
});

export const getAccessError = e => ({
    type: GET_ACCESS_ERROR,
    error: true,
    payload: e,
});

export const updateUserAccessRequests = () => ({
    type: UPDATE_ACCESS_REQUESTS,
});

export const updateAccessSuccess = () => ({
    type: UPDATE_ACCESS_SUCCESS,
});

export const updateAccessError = e => ({
    type: UPDATE_ACCESS_ERROR,
    error: true,
    payload: e,
});

export const deleteUserAccessRequests = (loadingId) => ({
    type: DELETE_ACCESS_REQUESTS,
    payload:loadingId,
});

export const deleteAccessSuccess = () => ({
    type: DELETE_ACCESS_SUCCESS,
});

export const deleteAccessError = e => ({
    type: DELETE_ACCESS_ERROR,
    error: true,
    payload: e,
});

export const fetchAccessRequests = (params) => (dispatch, getState, sdk) => {
    dispatch(getUserAccessRequests());
    return getAccessRequests({})
        .then((res) => {
            dispatch(getAccessSuccess(res.data));
        })
        .catch((e) => dispatch(getAccessError(e)));
}

export const updateState = (params) => (dispatch, getState, sdk) => {
    dispatch(updateUserAccessRequests());
    return updateAccessRequest(params)
     .then((res) => {
            dispatch(updateAccessSuccess());
            dispatch(fetchAccessRequests());

        })
        .catch((e) => dispatch(updateAccessError(e)));

}

export const fetchOwnAccessRequests = (params) => (dispatch, getState, sdk) => {
    dispatch(getOwnUserAccessRequests());
    return getOwnAccessRequests({})
        .then((res) => {
            dispatch(getOwnAccessSuccess(res.data));
        })
        .catch((e) => dispatch(getOwnAccessError(e)));
}

export const deleteRequest = (params) => (dispatch, getState, sdk) => {
    console.log('params',params)
    dispatch(deleteUserAccessRequests(params._id));
    return deleteAccessRequest(params)
     .then((res) => {
            dispatch(deleteAccessSuccess());
              if (params.type === 'requests') {
                dispatch(fetchAccessRequests()); 
            } else if (params.type === 'ownrequests') {
                dispatch(fetchOwnAccessRequests());  
            } 

        })
        .catch((e) => dispatch(updateAccessError(e)));

}

export const createAccess = (params) => (dispatch, getState, sdk) => {
    dispatch(createAccessUserRequest());
    const { userEmail } = params

     return createAccessRequest({ targetUserEmail: userEmail })
        .then((res) => {
            if (res.success) {
                dispatch(createAccessSuccess('Begäran har skickats'));
                dispatch(fetchOwnAccessRequests());  
                return res;
            } else {
                dispatch(createAccessError(res.error));  
            }
        })
        .catch((err) => {
            console.error('Error in createAccessRequest:', err);
            dispatch(createAccessError("Vi kunde inte hitta en användare med den här e-postadressen."));
        });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
    dispatch(setInitialState());

    return Promise.all([
        dispatch(fetchAccessRequests())
    ]);
};